












import { Component, Prop, Vue } from 'vue-property-decorator'
import { Getter } from 'vuex-class'

@Component
export default class TranscriptionStatusCard extends Vue {
  @Prop(Number) progress!: number
}
